export default __webpack_public_path__ + "static/media/wave1.5c6125a9.svg";